<template>
  <div class="p-price">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
        <ul class="price">
          <li>所有版本均支持</li>
          <li
            v-for="(item, index) in baseData.list"
            :index="index"
            :key="item + index"
          >
            <KdIcon
              :icon="item.icon"
              :size="20"
              margin="0 8px 0 0"
              :rightText="item.name"
              textSize="18"
            ></KdIcon>
          </li>
        </ul>
      </div>
    </div>
    <!-- 套餐区域 -->
    <PricePkgs />
    <div class="p-block-more">
      <kd-link type="primary" @click="toPrice">
        <KdIcon
          icon="ArrowRightS"
          :size="24"
          fill="currentColor"
          margin="0 0 0 3px"
          leftText="查看完整套餐"
          textSize="18"
        ></KdIcon>
      </kd-link>
    </div>
  </div>
</template>

<script>
import { priceData } from '@/views/homeV2/config.js';
import KdIcon from '@/components/KdIcon/index.vue';
import PricePkgs from '@/components/PricePkgs';

export default {
  name: 'edu-component',
  components: { KdIcon, PricePkgs },
  data() {
    return {
      baseData: priceData,
    };
  },
  methods: {
    toPrice() {
      this.$emit('homeCallback', {
        banOpen: true,
        dwClickName: 'look_complete_introduction',
      });
      this.$router.push('/price?fromPage=edu_web_home_page');
    },
  },
};
</script>

<style lang="scss" scoped>
.p-price {
  background: linear-gradient(
    180deg,
    rgba(246, 249, 251, 0) 6.19%,
    #f6f9fb 30.58%,
    rgba(246, 249, 251, 0) 93.3%
  );
  ul.price {
    li:nth-child(2) :deep(.target) {
      color: rgba(255, 21, 34, 1);
    }
  }
}
.p-block {
  margin-bottom: 40px;
}
</style>
